<freud-card>
	<div class="zk-flex zk-flex-col zk-gap-2">
		<div class="zk-flex zk-flex-col zk-gap-4">
			<div class="zk-flex zk-flex-row zk-gap-4">
				<img src="/assets/icons/clari-pro.svg" width="50" height="50" alt="Clari Pro Logo" />
				<div class="zk-flex zk-flex-col">
					<p class="insights-sugestions-title" freud-typography fontType="h5BoldAuto">
						{{ 'INSIGHTS.SUGESTIONS.TITLE' | translate }}
					</p>
					<p class="insights-sugestions-description" freud-typography fontType="h5RegularAuto">
						{{ 'INSIGHTS.SUGESTIONS.DESCRIPTION' | translate }}
					</p>
				</div>
			</div>
			<insights-tiers-sugestions *ngIf="!hasAllTiers() && !isLoadingTiers" [activeTiers]="activeTiers"></insights-tiers-sugestions>
		</div>
		<p *ngIf="!hasAllTiers() && !isLoadingTiers" class="insights-sugestions-others" freud-typography fontType="h5RegularAuto">
			{{ 'INSIGHTS.SUGESTIONS.OTHER_SUGESTIONS' | translate }}
		</p>
		<div class="zk-flex zk-flex-row zk-items-center zk-justify-between">
			<div class="zk-flex zk-justify-between insights-wrapper">
				<div class="zk-flex zk-gap-4 insights-questions">
					<div class="question" *ngFor="let sugestion of insightSugestions">
						<a target="_blank" rel="noreferrer" [href]="sugestion.link" (click)="trackClariSuggestionOpen(sugestion.value)">
							{{	sugestion.title | translate }}
						</a>
					</div>
				</div>
				<div class="insights-actions zk-flex zk-gap-2">
					<span
						class="freud-icon freud-icon-chevron-left"
						[ngClass]="{ 'icon-disabled': isScrollDisabled('left') }"
						(click)="changePage('left')"
					></span>
					<span
						class="freud-icon freud-icon-chevron-right"
						[ngClass]="{ 'icon-disabled':  isScrollDisabled('right')}"
						(click)="changePage('right')"
					></span>
				</div>
			</div>
		</div>
	</div>
</freud-card>
